import Form from './Form'
import FormSkeleton from './FormSkeleton'

export default function DocumentFormIndex({ document, loading }) {

  if (loading) return <FormSkeleton />

  return <Form document={document} />
}
